import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BrandingContext = createContext({});

const hexToHsl = (hex) => {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!match) return null;
  const int = parseInt(match[1], 16);
  const r = ((int >> 16) & 255) / 255;
  const g = ((int >> 8) & 255) / 255;
  const b = (int & 255) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({});

  useEffect(() => {
    api
      .get("/branding")
      .then((res) => {
        const data = res.data || {};
        setBranding(data);
        if (data.name) document.title = `${data.name} — Dashboard`;
        const hsl = hexToHsl(data.primary_color);
        if (hsl) {
          const root = document.documentElement;
          root.style.setProperty("--primary", `${hsl.h} ${hsl.s}% ${hsl.l}%`);
          root.style.setProperty("--ring", `${hsl.h} ${hsl.s}% ${hsl.l}%`);
          root.style.setProperty("--primary-foreground", hsl.l > 60 ? "0 0% 10%" : "0 0% 98%");
        }
      })
      .catch(() => {});
  }, []);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
